export function getLoginPath() {
  return '/login'
}
